import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import FinalMiniHome from '../FinalMiniHome';
import { routes as GameContextRoutes } from '../../GameContext/GameContextDataContainer';
import { routes as TapStoryRoutes } from '../../TapStory/containers/TapStoryDataContainer';

const routes = [{
    path: '/:teams?/:year?/:month?/:day?/:gamepk/final/:tab?/:detail?',
    exact: false,
    routes: [
        ...GameContextRoutes,
        ...TapStoryRoutes
    ]
}];

const FinalMiniHomeDataContainer = () => {
    return (
        <ErrorBoundaryWrapper componentName='FinalMiniHomeDataContainer'>
            <FinalMiniHome />
        </ErrorBoundaryWrapper>
    );
};

export default FinalMiniHomeDataContainer;
export { routes };
